'use strict';
/**
 * @type {NodeListOf<HTMLInputElement>}
 * */ var colectionInputs = document.querySelectorAll('form input');
colectionInputs.forEach(function(input) {
    var label = document.createElement('label');
    var labelText = input.name[0].toUpperCase() + input.name.slice(1);
    input.placeholder = labelText;
    label.textContent = labelText;
    label.classList.add('field-label');
    label.setAttribute('for', input.id);
    input.parentElement.prepend(label);
});

//# sourceMappingURL=js_task_fix_form_DOM.96e7e1d5.js.map
